import { CustomModal } from '../../CustomModal'
import { Button, Form, Input, Upload, Alert } from 'antd'
import React from 'react'
import './index.less'

export function ModalMsCredential(props: { visible: boolean; handleClose: () => void; onFinish: (values: Record<string, unknown>) => Promise<void> }) {
  const [form] = Form.useForm()

  return (
    <CustomModal
      isVisible={props.visible}
      handleClose={props.handleClose}
      secondaryBtnTitle="Cancel"
      handleClickPrimaryBtn={form.submit}
      primaryBtnTitle="Save"
      title="Link to Medispring Platform"
    >
      <div className="modalMsCredential">
        <Form className="modalMsCredential__form" layout="vertical" colon={false} form={form} onFinish={props.onFinish}>
          <Alert
            message="This will link your Preventi account to the Medispring platform, allowing you to perform prescriptions and create invoices on your Preventi patient.."
            type="info"
          ></Alert>
          <Form.Item name="msLogin" label="MS Login" rules={[{ required: true, message: 'Medispring login is required' }]}>
            <Input placeholder="MS login" size="large" autoFocus />
          </Form.Item>
          <Form.Item name="msPassword" label="MS Password" rules={[{ required: true, message: 'Medispring password is required' }]}>
            <Input type="password" placeholder="MS password" size="large" autoFocus />
          </Form.Item>
        </Form>
      </div>
    </CustomModal>
  )
}
